import normalMode from "../normalMode";
import { EventParamsTypeConstant } from "../prefab/const/EventParamsTypeConstant";
import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import gameConfig from "../../../engines/configs/gameConfig";
import winPage from "../prefab/page/winPage";
import weChatTriggerTimeLinks, { getOneWeChatTriggerTimeLinkById } from "../config/WeChatTriggerTimeLinkConfig";
import { getOneChitAryById } from "../config/WeChatChitChatConfig";
import normalEvents_New, { getOneNormalEventNewById } from "../config/normalEvent_NewConfig";
import WeChatManager from "./WeChatManager";
import { backPackEventMap } from "../config/BackpackEventConfig";
import StockBankruptcyPrefab from "../prefab/stock/StockBankruptcyPrefab";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../BundleResourceConfig";
import normalChatEvent_New from "../prefab/event_New/normalChatEvent_New";
import backpackManager from "./backpackManager";
import {
    AccountItem,
    DelayTimeEventInfo,
    normalBackPackSaveMap, NormalEvent_New,
    NormalLotteryMachineI,
    NormalModeDataI, NormalStockI, NormalStockPriceI,
    PawnRansomAdInfo,
    TaskDataMap,
    TouchCardLevelInfo,
    WeChatTrigger,
    WeChatTriggerLink,
    WeChatTriggerTimeLink
} from "./DefineInterface";
import clamShellManager from "./clamShellManager";
import openOreManager from "./openOreManager";
import stallManager from "./stallManager";
import { cooperativeShopSaveItem, getBankCooperativeAry, getBankCooperativeMap, getBreedCooperativeAry, getBreedCooperativeMap, getCooperativeShopMap } from "../prefab/cooperativePrefab/cooperativeConst";
import DriftBattleManager from "../prefab/lakeNode/manager/DriftBattleManager";
import cooperativeBankPage from "../prefab/cooperativePrefab/cooperativeBankPage";
import loveStoryManager from "./loveStoryManager";
import bannerManager from "./bannerManager";
import normalEventNewBase from "../prefab/event_New/normalEventNewBase";
import pawnShopManager from "./pawnShopManager";
import { SettleLawsuitKind } from "../../define/SettleLawsuitKind";
import CsvDataManage from "../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../define/CsvFileKind";
import utilsView from "../../../engines/libs/utilsView";
import { FileKind } from "../../define/FileKind";
import { UI_Z_INDEX } from "../../../engines/modules/uiModule";
import loanPage from "../prefab/cooperativePrefab/loanPage";
import { MessageEventKind } from "../../define/MessageEventKind";
import { GeneralKind } from "../../define/GeneralKind";
import TaskDataManage from "./TaskDataManage";
import DataVariationManage from "./DataVariationManage";
import { ConditionKind } from "../../define/ConditionKind";
import { LotteryKind } from "../prefab/lottery/common/data/LotteryKind";
import UserDataManage from "../model/UserDataManage";
import utilsModel from "../../../engines/libs/utilsModel";
import { OpenOreDataSaveType } from "../prefab/openOreGame/openOreConst";
import { SuperPowerKind } from "../../define/SuperPowerKind";
import { TouchCardKind } from "../prefab/touchCard/common/data/TouchCardKind";
import { MatchMiaiKind } from "../../define/MatchMiaiKind";
import { GamblerDataSaveType, TreasureMapCollect } from "../prefab/gamblerGame/gamblerGameConst";
import { kaoguDataType } from "../prefab/kaogu/kaogu/config/kaoguDataHelp";
import { oilfieldDataType } from "../prefab/oilfield/config/oilfieldDataHelp";
import { UIKind } from "../../define/UIKind";
import { MansionKind } from "../../define/MansionKind";




/**
 * 游戏主Manager
 */
export default class NormalGameManager {

    static _instance: NormalGameManager
    weChatManager: WeChatManager;

    clamShellManager:clamShellManager;
    backpackManager:backpackManager;
    openOreManager:openOreManager;
    stallManager:stallManager;
    loveStroyManager:loveStoryManager;
    bannerManager:bannerManager;
    pawnShopManager:pawnShopManager;
    taskDataManage: TaskDataManage;
    /** 时间统计频率 */
    private timeCountHz = 0;

    constructor(gameLayer: normalMode) {

        
        NormalGameManager._instance = this;
        UserDataManage.instance.loadLocationData();
        this.driftBattleManager = new DriftBattleManager();
        this.mGameLayer = gameLayer;
        this.loadGameHours();
        this.loadGameMinute();
        this.loadSpecialEventArray();
        this.loadHasTriggerMoodEventIdArray();
        this.loadHasTriggerHealthEventIdArray();
        this.loadFirstJumpDay();
        this.loadLastRestTime();
        this.loadPriceRiseRadio();
        this.loadGameData();
        this.loadAllAutoEvent();

        this.weChatManager = new WeChatManager(this.mGameLayer);
        this.backpackManager = new backpackManager(this);
        this.clamShellManager = new clamShellManager(this);
        this.openOreManager = new openOreManager(this);
        this.stallManager = new stallManager(this);
        this.loveStroyManager = new loveStoryManager(this);
        this.bannerManager = new bannerManager(this);
        this.pawnShopManager = new pawnShopManager(this);
        this.taskDataManage = new TaskDataManage(this);
        this.backNotSell();

        //开始检查闲置  提醒
        // this.startCheckIdleNotice();
        // let map = backPackEventMap();
        // for(let k in map){
        //     let b = map[k];
        //     this.onPushGoods(b.id,1);
        // this.onPushGoods(10054,1);
        // this.onPushGoods(40001,1);
        // this.onPushGoods(40002,10);
        // this.onPushGoods(10053,1);
        // this.onPushGoods(50020,10);
        // }

        // let bank = getBankCooperativeAry();
        // for(let i of bank){
        //     this.registerOneBankBusiness(i.id);
        // }

        // let breed = getBreedCooperativeAry();
        // for(let i of breed){
        //     this.registerOneBreedBusiness(i.id);
        // }
        if ( !this.getGameData().breedCooperativeData
         || this.getGameData().breedCooperativeData.length == 0 ) {
            this.registerOneBreedBusiness( 1 );
        }
        if(!this.getGameData().bankCooperativeData || this.getGameData().bankCooperativeData.length == 0){
            for(let i = 0;i<4;i++){
                this.registerOneBankBusiness(i + 1);
            }
        }
        this.timeCountDown();

        this.loadPatch();
        // this.openEvenRightNow("1001")

        this.taskDataManage.dataCompatibility();
    }

    loadPatch() {
        let propData = this.getOneGood(GeneralKind.PropId.CUPID_ARROW_ID);
        if (propData && propData.num > 0) {
            let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
            matchMiaiDataManage.addCupidArrow();
        }
    }

    backNotSell(){
        let back = this.getGameData().backpack;
        if(back){
            for(let key in back){
                let k = back[key];
                k.isSell = false;
            }
        }
    }

    private gamePauseFlag: boolean = false;
    /**
         * 倒计时
         */
    timeCountDown() {
        if (!this.gamePauseFlag) {
            this.calcTimeDay();
            this.setGameHours(GeneralKind.GeneralValue.GAME_TIME_JUMP, true);
            this.calcTimeDay();
            this.spliceCooperativeByTime();
            this.loveStroyManager.triggerRules();
        }
        this.mGameLayer.scheduleOnce(() => {
            this.timeCountDown( );
        }, 1);
    }

    /**
     * 暂停
     */
    pauseTimer() {
        this.gamePauseFlag = true;
    }

    /**
     * 重启游戏
     */
    resumeTimer() {
        if (this.gamePauseFlag == false) {
            return;
        }
        this.gamePauseFlag = false;
        // this.timeCountDown();
    }

    getGameIsPause(){
        return this.gamePauseFlag;
    }

    private readonly ContinuesWorkHour_KEY: string = 'continues-work-hour';
    private readonly GameHours_KEY: string = 'game-hours';
    private readonly GameMinute_KEY: string = 'game-minute';
    private readonly SpecialEventArray_KEY: string = 'special-event-array';
    private readonly HasTriggerMoodEventIdArray_KEY: string = 'has-trigger-mood-event-id-array';
    private readonly HasTriggerHealthEventIdArray_KEY: string = 'has-trigger-health-event-id-array';

    private readonly first_Jump_Day_Key: string = "first-jump-day-key";
    private readonly last_rest_key: string = "last-rest-key";
    private readonly price_rise_ratio_key: string = "price-rise-ratio-key";

    private lastRestTime: number = 0;
    private isFirstJumpDay: boolean = false;

    mContinuesWorkHour: number = 0;//连续工作时间
    mGameHours: number = 0;//游戏时间 小时
    mMinute: number = 0;//分钟
    specialEventArray: RegisterSpecialEventEntity[] = [];//特殊事件数组

    //当前价格 比率
    static rateFee: number = 1;
    //天数
    rateDays: number = gameConfig.FEE_RATE_INTERVALS_DAYS;

    //已经触发的心情事件Id
    hasTriggerMoodEventIdArray: number[] = [];
    //已经触发的健康事件Id
    hasTriggerHealthEventIdArray: number[] = [];

    mGameLayer: normalMode;
    driftBattleManager : DriftBattleManager;

    private priceRiseRatio: number = 0;

    //股票刷新次数
    private stockRestCount: number = 0;
    _currRunSeconds : number = 0;
    //倍率
    priceRate : number = 1;

    /**
     * 获取当前倍率
     */
    getPriceRate(){
        return 1 + ( this.getCurrentDay() / gameConfig.ADD_INTERVAL_DAYS ) * gameConfig.INTERVAL_ADD_NUM;
    }

    //数据存储的key
    private normal_Mode_Data_Save_Key: string = "normal-mode-data-save-key";
    //游戏数据
    private _gameData: NormalModeDataI = {
        m_reputation: 0,
        m_officialLv: 1,
        plotDialogue: false,
        switchVoice: true,
        switchVibration: true,
        switchVoiceEffect: true,
        userHeadArray: ["1"],
        userCurrHead: "1",
        userAccountInfo: [],
        weChatLinks: [],
        eventQueue: [],
        todayEvent: [],
        ariseEvent: [],
        ariseLinks: [],
        firstEnterLayer: [],
        randomEventCount: [],
        fixedTimeEvent: null,
        todayTimeEvents: [],
        nvWaStore: [],
        treasureMap: [],
        bFirstEnterPawn: false,
        bFirstJob: false,
        bFirstBuyStore: false,
        agreeCupidHelp2: false,
        agreeTakeCow: false,
        bShowSuperPowerBtn: false,
        bShowKongTongBtn: false,
        bTouchCardConWin: false,
        touchCardLevelLock: <TouchCardLevelInfo>{},
        pawnRansomAdCount: <PawnRansomAdInfo>{},
        loanCount: 0,
        lottery888Count: 0,
        todayAuctionNum: 0,
        todayEventCount: 0,
        curGoodValue: 0,
        lastAdGoodData: 0,
        lastRecordSubGood: 0,
        goldFlowerLotteryNum: 0,
        bBuyMansion: false,
        bCanMilitaryMap: false,
        backpack:<normalBackPackSaveMap>{},
        lotteryMachineData:<NormalLotteryMachineI>{},
        taskDataMap:<TaskDataMap>{},
        ariseLotteryNumbers: [],
        stockArray: [],
        stockPriceArray: [],
        todayDate: "",
        lotteryInfo: { gglValidCount: 0, hjGGLValidCount: 0, currGGLPurchaseCount: 0, currGJGGLPurchaseCount: 0, currSuperGGLPurchaseCount: 0 ,currNewGGLPurchaseCount : 0},
        chickenData :[],
        curLotteryNum :[],
        curTouchCardNum :[],
        chickenCoop : { capacity : 8 },
        bankCooperativeData:[],
        breedCooperativeData:[],
        phoenixEggFlag : false,
        dragonEggFlag : false,
        hasBreedCooperativeData : [],
        hasBankCooperativeData:[],
        hasShopCooperativeData:[],
        driftBattleData : [],
        delayDriftBattleData : [],
        chickenCertification : 0,
        shellCollectDay : null,
        investPaitendFlag:false,
        todayBattleCount : 0 ,
        accumulationBattleCount : 0,
        idleNoticeFlag : false,
        todaySettleLawsuitUseCount: 0,
        lastRefreshCaseDate: 0,
        settleLawsuitList: [],
        delayTimeEventList: [],
        lastLoginDayTime: 0,
        investToDayAriseAry:[],
        taskDataList:[],
        lastRecvWaterTransport:0,
        missGameUnlockWeapons:['' + SettleLawsuitKind.GeneralValue.DEFAULT_WEAPON],
        arrestSelectWeapon: SettleLawsuitKind.GeneralValue.DEFAULT_WEAPON + '',
        bMeetGongfu1: false,
        bNewTask: false,
        bNewFinshTask: false,
        saveCupidFlag:false,
        finishCupidLv1Time:0,
        saveArcheryFlag:false,
        isJoinTakeCow:false,
        liBaiGoodValue:0,
        finishChatedIdM:{},
        isFirstLiBai:true,
        isDeliveryWings:false,
        bFinishBoastGuiFei:false,
        bEnterBoastGuiFei:false,
        boastGuiFeiAdCount:0,
        touchCardConWin:0,
        kaoguData:<kaoguDataType>{},
        oilfieldData:<oilfieldDataType>{},
        wechatRecordPoint:[],
        escortGoodsEnterCount:[],
        firstDartFlag:true,
        firstPassDartFlag:true,
        bEnterYabiao2:false,
        bEnterYabiao1:false,
        bFirstFinishYabiao1:false,
        bOpenHitRobEvent:false,
        bFinishHitRobEvent:false,
        bFinishHitRob:false,
        bFinishHelpWife:false,
        bCompensateAward1:false,
        bGetPawnSpecialGoods1:false,
        bMarryPawnBoos:false,
        bTouchOilFieldBlack:false,
        bGrilAwardSui:false,
        bSkipPlot:false,
        skipPlotAdCount:0,
        takeCowAlreadyWave:[],
        hitRobAdList:[],
        goldFlowerTriggerPatind:false,
        isFirstBreakCode:true,
        isFirstOutSize:true,
    };

    resetGameData() {
        /** 默认武器 */
        let daultWeapon = SettleLawsuitKind.GeneralValue.DEFAULT_WEAPON;
        this._gameData = {
            m_reputation: 0,
            m_officialLv: 1,
            plotDialogue: false,
            switchVoice: true,
            switchVibration: true,
            switchVoiceEffect: true,
            userHeadArray: ["1"],
            userCurrHead: "1",
            userAccountInfo: [],
            weChatLinks: [],
            eventQueue: [],
            todayEvent: [],
            ariseEvent: [],
            ariseLinks: [],
            firstEnterLayer: [],
            randomEventCount: [],
            fixedTimeEvent: null,
            todayTimeEvents: [],
            nvWaStore: [],
            treasureMap: [],
            bFirstEnterPawn: false,
            bFirstJob: false,
            bFirstBuyStore: false,
            agreeCupidHelp2: false,
            agreeTakeCow: false,
            bShowSuperPowerBtn: false,
            bShowKongTongBtn: false,
            bTouchCardConWin: false,
            touchCardLevelLock:  <TouchCardLevelInfo>{},
            pawnRansomAdCount: <PawnRansomAdInfo>{},
            loanCount: 0,
            lottery888Count: 0,
            todayAuctionNum: 0,
            todayEventCount: 0,
            curGoodValue: 0,
            lastAdGoodData: 0,
            lastRecordSubGood: 0,
            goldFlowerLotteryNum: 0,
            bBuyMansion: false,
            bCanMilitaryMap: false,
            backpack:<normalBackPackSaveMap>{},
            ariseLotteryNumbers: [],
            lotteryMachineData:<NormalLotteryMachineI>{},
            stockArray: [],
            stockPriceArray: [],
            todayDate: "",
            lotteryInfo: { gglValidCount: 0, hjGGLValidCount: 0, currGGLPurchaseCount: 0, currGJGGLPurchaseCount: 0, currSuperGGLPurchaseCount: 0 ,currNewGGLPurchaseCount : 0},
            chickenData :[],
            curLotteryNum :[],
            curTouchCardNum :[],
            chickenCoop : { capacity : 8 },
            bankCooperativeData:[],
            breedCooperativeData:[],
            phoenixEggFlag : false,
            dragonEggFlag : false,
            hasBreedCooperativeData : [],
            hasBankCooperativeData:[],
            hasShopCooperativeData:[],
            driftBattleData : [],
            delayDriftBattleData : [],
            chickenCertification : 0,
            shellCollectDay : null,
            investPaitendFlag:false,
            todayBattleCount : 0 ,
            accumulationBattleCount : 0,
            idleNoticeFlag : false,
            todaySettleLawsuitUseCount: 0,
            lastRefreshCaseDate: 0,
            settleLawsuitList: [],
            delayTimeEventList: [],
            lastLoginDayTime: 0,
            investToDayAriseAry:[],
            taskDataList:[],
            taskDataMap:<TaskDataMap>{},
            kaoguData:<kaoguDataType>{},
            oilfieldData:<oilfieldDataType>{},
            lastRecvWaterTransport:0,
            missGameUnlockWeapons:[daultWeapon],
            arrestSelectWeapon: daultWeapon,
            bMeetGongfu1: false,
            bNewTask: false,
            bNewFinshTask: false,
            saveCupidFlag:false,
            finishCupidLv1Time:0,
            saveArcheryFlag:false,
            isJoinTakeCow:false,
            liBaiGoodValue:0,
            finishChatedIdM:{},
            isFirstLiBai:true,
            isDeliveryWings:false,
            bFinishBoastGuiFei:false,
            bEnterBoastGuiFei:false,
            boastGuiFeiAdCount:0,
            touchCardConWin:0,
            wechatRecordPoint:[],
            escortGoodsEnterCount:[],
            firstDartFlag:true,
            firstPassDartFlag:true,
            bEnterYabiao2:false,
            bEnterYabiao1:false,
            bFirstFinishYabiao1:false,
            bOpenHitRobEvent:false,
            bFinishHitRobEvent:false,
            bFinishHitRob:false,
            bFinishHelpWife:false,
            bCompensateAward1:false,
            bGetPawnSpecialGoods1:false,
            bMarryPawnBoos:false,
            bTouchOilFieldBlack:false,
            bGrilAwardSui:false,
            bSkipPlot:false,
            skipPlotAdCount:0,
            takeCowAlreadyWave:[],
            hitRobAdList:[],
            goldFlowerTriggerPatind:false,
            isFirstBreakCode:true,
            isFirstOutSize:true,
        };
        
        this.writeGameData();
    }
    //加载游戏数据
    loadGameData() {
        let dataStr: string = O1HD.getServices().localStorageSrv.getStorage(
            this.normal_Mode_Data_Save_Key) 
            || JSON.stringify(this._gameData);
        let data = JSON.parse(dataStr);
        this.setGameData(data, false);
        // this.loadAllNpc();
        // this._gameData = JSON.parse(dataStr);
    }
    //设置游戏数据
    setGameData(data: NormalModeDataI, isPlus: boolean = false, node: cc.Node = O1HD.Canvas()) {
        for (let key in data) {
            let k = data[key];
            if (k != null) {
                if (k instanceof Array) {
                    if (isPlus) {
                        this._gameData[key] = this._gameData[key].concat(k);
                    } else {
                        this._gameData[key] = [].concat(k);
                    }
                    if(key == "backpack"){
                        this._gameData[key] = <normalBackPackSaveMap>{};
                    }
                } else {
                    if (isPlus) {
                        this._gameData[key] += k;
                        if (key == "_coin" && node && node.isValid) {
                            if (k > 0) {
                                O1HD.getManagers().gameMgr.ChaoPiaoAni(node, O1HD.getManagers().gameMgr.chaoPiaoInitPos);
                            }
                        }
                    } else {
                        this._gameData[key] = k;
                    }
                }
            }
        }
        this.writeGameData();
    }
    //获取游戏数据
    getGameData() {
        return this._gameData;
    }
    //写入游戏数据
    writeGameData() {
        O1HD.getServices().localStorageSrv.setStorage(
            this.normal_Mode_Data_Save_Key
            , JSON.stringify(this._gameData));
    }

    /**
     * 检查是否游戏失败
     */
    checkGameStatus(  ){
        if ( this.getGameData().gameFail == 1 ) {
            this.openResultPage();
        }
    }

     /**
     * 每天重置抽奖次数
     */
     curDayResetLotteryData() {
        let list = LotteryKind.LotteryList;
        let touchList = TouchCardKind.ItemList
        let gameData = this.getGameData();
        for(let i = 0; i < list.length; i++) {
            let o = list[i];
            let idx = o.idx;
            gameData.curLotteryNum[idx] = 0;
        }

        for (let i = 0; i < touchList.length; i++) {
            let o = touchList[i];
            let idx = o.idx;
            gameData.curTouchCardNum[idx] = 0;
        }

        gameData.escortGoodsEnterCount = [];
    }

    curDayResetTouchCardData() {
        let list = TouchCardKind.ItemList;
        let gameData = this.getGameData();
        for(let i = 0; i < list.length; i++) {
            let o = list[i];
            let idx = o.idx;
            gameData.curTouchCardNum[idx] = 0;
        }
    }

    /**
     * 当天结算
     * @param settlementFlag 结算开关
     */
    daySettlement(settlementFlag: boolean = false) {
        UserDataManage.instance.dayDataDispose();
        this.setGameData({ todayEvent: [], todayTimeEvents: [] });
        this.getGameData().lotteryInfo.currGGLPurchaseCount = 0;
        this.getGameData().lotteryInfo.currSuperGGLPurchaseCount = 0;
        this.getGameData().lotteryInfo.currGJGGLPurchaseCount = 0;
        this.getGameData().lotteryInfo.currNewGGLPurchaseCount = 0;
        this.getGameData().investToDayAriseAry = [];
        // this.getGameData().todaySettleLawsuitUseCount = 0;
        // this.writeGameData();
        this.triggerAutoEvent();
        this.mGameLayer.openDelayEvent();
        this.triggerWeChatTriggerLink();
        this.autoTriggerWeChatLink();
        this.driftBattleManager.registerCurrDayEvent( this.getCurrentDay() );
        this.setGameData({todayBattleCount:0} , false );
        this.pushEmergency();
        //每次天数改变,股票价格就会变化
        this.onStockPriceChange();
        this.taskDataManage.everyDayUpdateState();
        this.loveStroyManager.autoRegisterWithdrawChoose();
        let needPayMoney: number = 0;
        for (let item of this.getGameData().userAccountInfo) {
            if (item.hasPayDays >= (item.needPayDays-1)) {
                needPayMoney += (item.totalFee - item.everyDayPay * (item.needPayDays-1));
            } else {
                if (item.everyDayPay == 0) {
                    item.hasPayDays ++;
                } else {
                    needPayMoney += item.everyDayPay;
                }
            }
            // Math.floor(item.everyDayPay / item.needPayDays);
        }
        //判断是否足够偿还当天 债务
        if (O1HD.getServices().userSrv.getCoins() < needPayMoney) {
            //游戏失败
            this.openResultPage();
            return;
        }
        if (needPayMoney > 0 && this.getGameData().userAccountInfo.length > 0) {
            //打开今日
            this.openSuccessPage();
        }

        if ( this.getGameData().gameFail == 1) {
            return;
        }
        //重置彩票
        this.mGameLayer.shopLotteryFFCManager.reset();
        if (settlementFlag) {
            // let currDayHours = Math.floor(this.mGameHours % 24);
            // let surplusHours = 24 - Math.floor(currDayHours);
            //触发判定事件
            // this.mGameLayer.onBackNormal();
        }
        // 当天需要判定的事件
        let judgementStartHour: number = 24 * Math.floor(this.mGameHours / 24);
        let judgementEndHour: number = 24 * (Math.floor(this.mGameHours / 24) + 1);
        let triggerEventList = this.specialEventArray.filter((item, index, dataList) => {
            return (item.startHours + item.waitHours) > judgementStartHour 
            && (item.startHours + item.waitHours) < judgementEndHour;
        });

        this.specialEventArray = this.specialEventArray.filter((item, index, dataList) => {
            return !triggerEventList.find((itemTemp, indexTemp, dataListTemp) => {
                return itemTemp.desc == item.desc;
            });
        });

        this.writeSpecialEventArray();
        this.mGameLayer.setSpecialEventShow(triggerEventList);
        // 可能会触发的事件
        this.getGameData().todayEventCount = 0;
        this.getGameData().todayAuctionNum = 0;
        this.writeGameData();
        if (this.getNodeStr().length < 1 && this.mGameLayer.canShowFlag) {
            this.openOneNewEvent();
        }
        //触发贝壳刷新
        O1HD.emit("LakeNode.shellAppear" );
    }

    /**
     * 打开结果页面
     * @param resultFlag true 成功，false 失败
     */
    openResultPage() {
        this.openLoanPage("lose");    
    }

    async openLoanPage(type:string,complete?:(isTrue:boolean)=>void){
        this.addOneNodeStrs(UIKind.UILayerTag.LOAN_PAGE);
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.cooperativeGameBundle,"cooperativeGame/loanPage");
        let node:cc.Node = cc.instantiate(prefab);
        node.getComponent(loanPage).bindType(type,complete);
        O1HD.Canvas().addChild(node, 10);
    }

    openSuccessPage(){
        let pathName = "losePage";
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`prefab/page/${pathName}`
        , cc.Prefab, (err, asset: cc.Prefab) => {
            if (err) {
                console.log("加载结算界面失败", pathName);
                return;
            }
            let node: cc.Node = cc.instantiate(asset);
            let ns = node.getComponent(winPage);
            ns.bindLayer(this.mGameLayer);
            ns.todayPayment();
            O1HD.Canvas().addChild(node);
        });
    }

    /**
     * 添加 特殊事件
     * @param specialEventEntity
     */
    addSpecialEvent(specialEventEntity: RegisterSpecialEventEntity) {
        this.specialEventArray.push(specialEventEntity);
        this.writeSpecialEventArray();
    }


    /**
     * 影响事件处理
     */
    effectParamsDealWith(effectParams: { key: number, value: number }[]) {
        for (let effectParam of effectParams) {
            switch (effectParam.key) {
                case EventParamsTypeConstant.MOOD:
                    O1HD.getServices().userSrv.setMood(effectParam.value, true);
                    break;
                case EventParamsTypeConstant.MONEY:
                    O1HD.getServices().userSrv.setCoins(effectParam.value, true);
                    break;
                case EventParamsTypeConstant.HEALTH:
                    O1HD.getServices().userSrv.setHealth(effectParam.value, true);
                    if (O1HD.getServices().userSrv.getHealth() == 0) {
                        O1HD.getServices().userSrv.setGameFail(1);
                        // 玩家死亡 ，游戏失败
                        this.mGameLayer.scheduleOnce(() => {
                            this.openResultPage();
                        }, 4);
                    }
                    break;
                case EventParamsTypeConstant.DEATH:
                    //打开死亡 结束界面
                    this.openResultPage();
                    break;
            }
        }
    }

    //游戏时间
    setGameHours(gameMinute: number, isPlus: boolean) {
        let startDay: number = this.getCurrentDay();
        if (isPlus) {
            gameMinute = this.mMinute + gameMinute;
            if (gameMinute >= 60) {
                this.mGameHours += Math.floor(gameMinute / 60);
                this.mMinute = Math.floor(gameMinute % 60);
            } else {
                this.mMinute = Math.floor(gameMinute);
            }
            this.mGameLayer.triggerFixedTimeEvent();
        } else {
            this.mGameHours = 0;
            this.mMinute = Math.floor(gameMinute);
        }
        let endDay: number = this.getCurrentDay();

        this.triggerEmergency();

        if (isPlus && startDay != endDay) {
            if (endDay % this.rateDays == 0) {
                //如果整除
                NormalGameManager.rateFee += gameConfig.FEE_RATE_NUM;
            }
            this.daySettlement();
        }
        O1HD.getServices().localStorageSrv.setStorage(this.GameMinute_KEY, this.mMinute);
        O1HD.getServices().localStorageSrv.setStorage(this.GameHours_KEY, this.mGameHours);
    }

    calcTimeDay() {
        this.timeCountHz++;
        if (this.timeCountHz <= 3) {
            return;
        }
        this.timeCountHz = 0;

        if (this.isNextDay()) {
            // 第二天处理
            this.writeLoginDayTime();  
            this.nextDayData();
            this.setGameData({todaySettleLawsuitUseCount: 0});
        }
    }

     /**
     * 第二天数据处理
     */
     nextDayData() {
        this.curDayResetLotteryData();
    }

    isNextDay() {
        let curTime = Date.now();
        let lastLoginDayTime = this.getGameData().lastLoginDayTime;
        let bNextDay = data_control.isNextDay(
            curTime
            , lastLoginDayTime
        );
        return bNextDay;
    }

    loginSuccess() {
        if (this.isNextDay()) {
            this.nextDayData();
            this.setGameData({todaySettleLawsuitUseCount: 0});
        }
        this.writeLoginDayTime();
        
        // if (this.getGameData().lastLoginDayTime <= 0) {
        //     this.writeLoginDayTime();
        // }
    }

    writeLoginDayTime() {
        let curTime = Date.now();
        this.setGameData({lastLoginDayTime: curTime});
    }

    loadGameHours() {
        let data = O1HD.getServices().localStorageSrv.getStorage(this.GameHours_KEY);
        if (data == null || data === '') {
            this.mGameHours = 0;
        } else {
            this.mGameHours = Number(data);
        }
    }

    loadGameMinute() {
        let data = O1HD.getServices().localStorageSrv.getStorage(this.GameMinute_KEY);
        if (data == null || data === '') {
            this.mMinute = 0;
        } else {
            this.mMinute = Number(data);
        }
    }

    //特殊事件
    writeSpecialEventArray() {
        O1HD.getServices().localStorageSrv.setStorage(
            this.SpecialEventArray_KEY
            , JSON.stringify(this.specialEventArray));
    }
    loadSpecialEventArray() {
        let data = O1HD.getServices().localStorageSrv.getStorage(this.SpecialEventArray_KEY);
        if (data == null || data === '') {
            this.specialEventArray = [];
        } else {
            this.specialEventArray = JSON.parse(data);
        }
    }
    //心情事件id触发数组
    writeHasTriggerMoodEventIdArray() {
        O1HD.getServices().localStorageSrv.setStorage(
            this.HasTriggerMoodEventIdArray_KEY
            , JSON.stringify(this.hasTriggerMoodEventIdArray)
        );
    }
    loadHasTriggerMoodEventIdArray() {
        let data = O1HD.getServices().localStorageSrv.getStorage(this.HasTriggerMoodEventIdArray_KEY);
        if (data == null || data === '') {
            this.hasTriggerMoodEventIdArray = [];
        } else {
            this.hasTriggerMoodEventIdArray = JSON.parse(data);
        }
    }
    //健康事件id触发数组
    writeHasTriggerHealthEventIdArray() {
        O1HD.getServices().localStorageSrv.setStorage(this.HasTriggerHealthEventIdArray_KEY
            , JSON.stringify(this.hasTriggerHealthEventIdArray)
        );
    }
    loadHasTriggerHealthEventIdArray() {
        let data = O1HD.getServices().localStorageSrv.getStorage(this.HasTriggerHealthEventIdArray_KEY);
        if (data == null || data === '') {
            this.hasTriggerHealthEventIdArray = [];
        } else {
            this.hasTriggerHealthEventIdArray = JSON.parse(data);
        }
    }

    alive() {
        O1HD.getServices().userSrv.setStronger(gameConfig.ALIVE_STRONGER_COUNT, true);
        O1HD.getServices().userSrv.setGameFail(0);
    }

    getCurrentDay() {
        return Math.floor(this.mGameHours / 24);
    }

    getCurrentHour() {
        return this.mGameHours % 24;
    }

    getCurMinute() {
        return this.mMinute % 60;
    }

    getCurrentTimeString(){
        return this.getNumToCountNum(Math.floor(NormalGameManager._instance.mGameHours % 24)
            ,2) + ":" 
            + this.getNumToCountNum( Math.floor(NormalGameManager._instance.mMinute) ,2);
    }

    getNumToCountNum(num:number,count:number){
        let s = num.toString();
        if(s.length<count){
            let needCount:number = count - s.length;
            for(let i = 0;i<needCount;i++){
                s = "0" + s;
            }
        }
        return s;
    }

    getIsFirstJumpDay() {
        return this.isFirstJumpDay;
    }

    loadFirstJumpDay() {
        let is = O1HD.getServices().localStorageSrv.getStorage(this.first_Jump_Day_Key) || "false";
        if (is == "") {
            is = "false";
        }
        this.isFirstJumpDay = JSON.parse(is);
    }

    setFirstJumpDay(isFirst: boolean) {
        this.isFirstJumpDay = isFirst;
        this.writeFirstJumpDay();
    }

    writeFirstJumpDay() {
        O1HD.getServices().localStorageSrv.getStorage(this.first_Jump_Day_Key, this.isFirstJumpDay);
    }

    loadLastRestTime() {
        let lastStr = O1HD.getServices().localStorageSrv.getStorage(this.last_rest_key) || "0";
        let last: number = Number(lastStr);
        if (isNaN(last)) {
            last = 0;
        }
        this.lastRestTime = last;
    }

    setLastRestTime() {
        this.lastRestTime = this.mGameHours;
        this.writeLastRestTime();
    }

    resetLastRestTime() {/**/6
        this.lastRestTime = 0;
        this.writeLastRestTime();
    }

    private writeLastRestTime() {
        O1HD.getServices().localStorageSrv.setStorage(this.last_rest_key, this.lastRestTime);
    }

    //加载物价上调比例
    loadPriceRiseRadio() {
        let radio = O1HD.getServices().localStorageSrv.getStorage(this.price_rise_ratio_key) || "0";
        if (isNaN(Number(radio))) {
            radio = "0";
        }
        this.priceRiseRatio = Number(radio);
    }

    getPriceRiseRadio() {
        return this.priceRiseRatio;
    }

    //
    private writePriceRiseRadio() {
        O1HD.getServices().localStorageSrv.setStorage(this.price_rise_ratio_key, this.priceRiseRatio);
    }

    setPriceRiseRadio(radio: number) {
        this.priceRiseRatio = radio;
        this.writePriceRiseRadio();
    }

    //重置当前的manager
    resetManager() {
        O1HD.getServices().userSrv.reset();

        UserDataManage.instance.anewStart();
        this.setGameHours(0, false);
        this.specialEventArray = [];
        this.writeSpecialEventArray();
        this.hasTriggerHealthEventIdArray = [];
        this.writeHasTriggerHealthEventIdArray();
        this.hasTriggerMoodEventIdArray = [];
        this.writeHasTriggerMoodEventIdArray();
        this.setFirstJumpDay(true);
        this.resetLastRestTime();
        O1HD.getServices().localStorageSrv.setStorage("hotelPrefab-event-ids", 0);
        O1HD.getServices().localStorageSrv.setStorage("bathCenterPrefab-event-ids", 0);
        O1HD.getServices().localStorageSrv.setStorage("parkPrefab-event-ids", 0);
        
        O1HD.getServices().localStorageSrv.setStorage(OpenOreDataSaveType.OPEN_ORE_SAVE_KEY, '');
        O1HD.getServices().localStorageSrv.setStorage(OpenOreDataSaveType.OPEN_ORE_DAT_SAVE_KEY, '');
        O1HD.getServices().localStorageSrv.setStorage(OpenOreDataSaveType.OPEN_ORE_CUT_KEY, '');
        O1HD.getServices().localStorageSrv.setStorage(OpenOreDataSaveType.OPEN_ORE_CUTCOUNT_DAY_KEY, '');

        O1HD.getServices().localStorageSrv.setStorage(GamblerDataSaveType.GAMBLER_CUT_KEY, "0");
        O1HD.getServices().localStorageSrv.setStorage(GamblerDataSaveType.GAMBLER_CUTCOUNT_DAY_KEY, "");
        O1HD.getServices().localStorageSrv.setStorage(GamblerDataSaveType.GAMBLER_SAVE_KEY, "");
        O1HD.getServices().localStorageSrv.setStorage(GamblerDataSaveType.GAMBLER_DAT_SAVE_KEY, "");


        this.setPriceRiseRadio(0);
        this.weChatManager.resetGameData();
        this.resetGameData();
        this.loveStroyManager.resetManager();
        this.driftBattleManager.registerStartEvent();
        this.stallManager.resetManager();
        this.loginSuccess();
    }

    //TODO 此处会有一点小问题，但是无伤大雅（后续有时间再改）  问题如下
    //TODO 因为这个方法是将聊天加到队列前面 但是如果聊天线中后续还有聊天的话还是会按照之前的方式进行push（即放到队列最后面）  具体修改方式如下
    //TODO 在gameData的缓存中加一个unShift的队列专门处理需要unShift的聊天线  具体处理逻辑可参考push的逻辑
    addOneWeChatTriggerLinkUnShift(id: string) {
        if (!utilsModel.isValidNumberValue(id)) {
            return false;
        }
        let link: WeChatTriggerTimeLink = {
            startDay: this.getCurrentDay(),
            linkId: id
        }
        let Chatlink = getOneWeChatTriggerTimeLinkById(id);
        if(!this.checkWeChatLinkIsVaildByFront(Chatlink)){
            return false;
        }
        let gameData = this.getGameData();
        if (Chatlink.isOnly) {
            let ariseLink = gameData.ariseLinks;
            if (!ariseLink.includes(id)) {
                // console.log("加入一条线???????",id);
                gameData.weChatLinks.unshift(link);
                gameData.ariseLinks.push(id);
                this.writeGameData();
                this.triggerOneLink(link , true );
            } else {
                // console.log("加入聊天线失败：加入重复的聊天线");
            }
        } else {
            // console.log("??????????怎么回事??????????",id)
            gameData.weChatLinks.unshift(link);
            this.writeGameData();
            this.triggerOneLink(link , true );
        }
        return true;
    }

    /**
     * 添加一个延迟时间的事件
     * @param id 
     * @param delay 
     */
    addDelayTimeEvent(id: string, delay: number) {
        let event: DelayTimeEventInfo = {
            id: id,
            delayTime: delay,
            startTime: this.getCurrentDay(),
            bFinish: false,
        }
        this.getGameData().delayTimeEventList.unshift(event);
        this.writeGameData();
    }

    addOneWeChatTriggerLink(id: string) {
        let link: WeChatTriggerTimeLink = {
            startDay: this.getCurrentDay(),
            linkId: id
        }
        let Chatlink = getOneWeChatTriggerTimeLinkById(id);
        if(!this.checkWeChatLinkIsVaildByFront(Chatlink)){
            return false;
        }
        if (Chatlink.isOnly) {
            let ariseLink = this.getGameData().ariseLinks;
            if (!ariseLink.includes(id)) {
                // console.log("加入一条线???????",id);
                this.getGameData().weChatLinks.push(link);
                this.getGameData().ariseLinks.push(id);
                this.writeGameData();
                this.triggerOneLink(link);
            } else {
                // console.log("加入聊天线失败：加入重复的聊天线");
                return false;
            }
        } else {
            // console.log("??????????怎么回事??????????",id)
            this.getGameData().weChatLinks.push(link);
            this.writeGameData();
            this.triggerOneLink(link);
        }
        return true;
    }

    /**
     * 判断聊天线的前置条件是否合法
     * link 聊天线
     */
    checkWeChatLinkIsVaildByFront(link:WeChatTriggerLink){
        let front = link.front;
        if(!front || front == null){
            return true;
        }
        let symbolAry:string[] = [];
        let frontAry:string[] = [];
        let s = "";
        for(let i =0 ;i<front.length;i++){
            let f = front[i];
            if(f == "|" || f == "&"){
                frontAry.push(s);
                s = "";
                symbolAry.push(f);
                continue;
            }else{
                s += f;
            }
        }
        if(s!=""){
            frontAry.push(s);
        }

        if(symbolAry.length <= 0){
            // 判断单个条件是否成立
            return this.checkWeChatLinkFrontIsVaild(frontAry[0]);
        }else{
            // 判断多个条件是否成立
            let isVaild = this.checkWeChatLinkFrontIsVaild(frontAry[0]);
            for(let i = 0; i<symbolAry.length; i++){
                let symbol = symbolAry[i];
                let front = frontAry[i + 1];
                if(symbol == "|"){
                    isVaild = this.checkWeChatLinkFrontIsVaild(front) || isVaild;
                }else {
                    isVaild = this.checkWeChatLinkFrontIsVaild(front) && isVaild;
                }
            }
            return isVaild;
        }
    }

    /**
     * 判断单个条件是否成立
     * @param front 条件
     */
    checkWeChatLinkFrontIsVaild(front:string){
        if(front.includes("weChatTimeLink:")){
            // 判断微信聊天线
            let linkId = front.substring(15);
            let isVaild = this.getGameData().ariseLinks.includes(linkId);
            return isVaild;

        }else if(front.includes("loveStroyPeople:")){
            // 判断恋爱记是否绑定了人
            let loveStroyPeople = front.substring(16);
            let isVaild = this.loveStroyManager.getData().poeple[loveStroyPeople] != null;
            return isVaild;
        }
        return true;
    }

    autoTriggerWeChatLink() {
        let currentDay = this.getCurrentDay();
        let links = weChatTriggerTimeLinks();
        for (let l in links) {
            let link = links[l];
            if (link.autoTriggerDay != null && link.autoTriggerDay == currentDay) {
                this.addOneWeChatTriggerLink(link.id);
            }
        }
    }

    spliceOneWeChatTriggerLink(id: string | number) {
        let links = this.getGameData().weChatLinks;
        let index = links.findIndex(link => {
            return link.linkId == id;
        });
        if (index > -1) {
            links.splice(index, 1);
        }
        this.writeGameData();
    }

    triggerWeChatTriggerLink() {
        let links = this.getGameData().weChatLinks;
        let needDeleteLinks: WeChatTriggerTimeLink[] = [];
        for (let i = 0; i < links.length; i++) {
            let link = links[i];
            let linkId = link.linkId;
            let weChatLink = getOneWeChatTriggerTimeLinkById(linkId).link;
            let maxDay: number = this.getCurrentDay();
            for (let j = 0; j < weChatLink.length; j++) {
                let one: WeChatTrigger = weChatLink[j];
                let oneDay = one.currentDay + link.startDay;
                if (oneDay > maxDay) {
                    maxDay = oneDay;
                }
                // console.log(oneDay,this.getCurrentDay(),"12121212")
                if (oneDay == this.getCurrentDay()) {
                    let chitChat = getOneChitAryById(one.id);
                    let people = chitChat.people;
                    this.weChatManager.addOnePeople(people, one.id);
                    // console.log(people,one,"?????????怎么回事2222222222")
                }
            }
            if (this.getCurrentDay() == maxDay) {
                //需要删除的link
                needDeleteLinks.push(link);
            }
        }
        for (let i = 0; i < needDeleteLinks.length; i++) {
            this.spliceOneWeChatTriggerLink(needDeleteLinks[i].linkId);
        }
        this.writeGameData();
    }

    triggerOneLink(link: WeChatTriggerTimeLink , unshiftFlag : boolean = false ) {
        let linkId = link.linkId;
        let weChatLink = getOneWeChatTriggerTimeLinkById(linkId).link;
        // console.log(weChatLink,linkId,link,">>>>>>>>>>>>>>>>>>>>>>>>")
        let maxDay: number = this.getCurrentDay();
        for (let j = 0; j < weChatLink.length; j++) {
            let one: WeChatTrigger = weChatLink[j];
            let oneDay = one.currentDay + link.startDay;
            if (oneDay > maxDay) {
                maxDay = oneDay;
            }
            if (oneDay == this.getCurrentDay()) {
                let chitChat = getOneChitAryById(one.id);
                let people = chitChat.people;
                this.weChatManager.addOnePeople(people, one.id , unshiftFlag);
                // console.log(people,one,"?????????怎么回事11111111111");
            }
        }
        if (this.getCurrentDay() == maxDay) {
            //需要删除的link
            this.spliceOneWeChatTriggerLink(link.linkId);
        }
    }

    addOneEvent(id: string) {
        let event = getOneNormalEventNewById(id);
        let ariseEvent = this.getGameData().ariseEvent;
        if (event.isOnly && ariseEvent.includes(id)) {
            return;
        } else if (event.isOnly) {
            ariseEvent.push(id);
        }
        this.getGameData().eventQueue.push(id);
        this.writeGameData();
        // console.log(this.getGameData().eventQueue.length > 0, this.mGameLayer.canShowFlag, this.getNodeStr().length < 1, this.checkCanShowEvent(event));
        // if ((this.getGameData().eventQueue.length > 0 && this.mGameLayer.canShowFlag && this.getNodeStr().length < 1) || this.checkCanShowEvent(event)) {
        if ((this.getGameData().eventQueue.length > 0 
            && this.mGameLayer.canShowFlag && this.getNodeStr().length < 1) 
            || this.checkCanShowEvent(event)
        ) {
            this.openOneNewEvent();
            // this.mGameLayer.canShowFlag = false;
        }
    }

    autoEventAry: NormalEvent_New[] = [];

    /**
     * 立即打开一个事件
     * @param id 事件id
     */
    openEvenRightNow( id : string ){
        let event = getOneNormalEventNewById(id);
        let ariseEvent = this.getGameData().ariseEvent;
        if (event.isOnly && ariseEvent.includes(id)) {
            return;
        } else if (event.isOnly) {
            ariseEvent.push(id);
        }
        this.getGameData().eventQueue.unshift(id);
        this.openOneNewEvent().then();
    }


    //加载所有到时间触发的事件
    loadAllAutoEvent() {
        let map = normalEvents_New();
        for (let k in map) {
            let event = map[k];
            if ( event.startDay != null && event.startDay >= this.getCurrentDay() ) {
                // console.log(event);
                this.autoEventAry.push(event);
            }
        }
    }

    //触发到时间触发的事件
    triggerAutoEvent() {
        let currentDay = this.getCurrentDay();
        let spliceAry: NormalEvent_New[] = [];
        for (let i = 0; i < this.autoEventAry.length; i++) {
            let event = this.autoEventAry[i];
            if (currentDay == event.startDay) {
                console.log(event, "事件??????");
                this.addOneEvent(event.id);
                spliceAry.push(event);
            }
        }
        for (let i = 0; i < spliceAry.length; i++) {
            let sEvent = spliceAry[i];
            let index = this.autoEventAry.findIndex(e => {
                return e.id == sEvent.id;
            });
            if (index > -1) {
                spliceAry.splice(index, 1);
            }
        }
    }

    // 触发一个突发事件
    pushEmergency() {
        // if (this.getGameData().userAccountInfo.length > 0) {
        //     return;
        // }

        if (this.getGameData().todayTimeEvents.length > 0) {
            return;
        }

        let allEmergency: string[] = [];
        let eventMap = normalEvents_New();
        for (let k in eventMap) {
            let event = eventMap[k];
            let startDay = event.startDay;
            if (startDay == -1) {
                allEmergency.push(k);
            }
        }

        for (let i = 0; i < allEmergency.length; i++) {
            let eId = allEmergency[i];
            if (this.getGameData().eventQueue.includes(eId)) {
                return;
            }
            if (this.getGameData().todayTimeEvents.includes(eId)) {
                return;
            }
        }


        if (allEmergency.length > 0) {
            let r = Math.random();
            // console.log(r,"概率");
            if (r < 0.3) {
                let rand = data_control.getRandItemOfArray(allEmergency);
                // this.getGameData().todayTimeEvents.push(rand);
                this.addOneEvent(rand);
                this.writeGameData();
            }
        }
    }

    /**
     * 还清贷款设置
     * @param accountData 
    */
    payOffTheCreditDispose(accountData: AccountItem) {
        if (accountData.title == '赎金' && !this._gameData.bOpenHitRobEvent) {
            this._gameData.bOpenHitRobEvent = true;
            this.writeGameData();
        }
    }

     /** 打开补偿奖励 */
     openCompensateAwardLayer() {
        
        let gameData = this.getGameData();
        if (gameData.bCompensateAward1) {
            return;
        }

        // if (this.getNodeStr().length >= 1) {
        //     return;
        // }

        O1HD.getModules().uiControlModule.showLoading();
        this.addOneNodeStrs(UIKind.UILayerTag.CompensateAwardLayer1);
        utilsView.openPopupLayer(
            'prefab/CompensateAwardLayer1'
            , BUNDLE_SMALL_NAME.normalMode
        );
    }

    pawnBossMarryDataDispose() {
        let gameData = this.getGameData();
        if (gameData.bGetPawnSpecialGoods1 && !gameData.bMarryPawnBoos) {
            let wifeData = UserDataManage.instance.mansionDataManage.wifeDataManage.wifeData;
            let wifeId = MansionKind.GeneralValue.SHEN_NA_NA;
            let wData = wifeData.lists.get(wifeId);
            if (!wData || wData.state != MansionKind.WifeState.WIFE) {
                let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.WIFE, wifeId);
                if (!info) {
                    console.error(`未找到数据 WIFE wifeId = ` + wifeId);
                    return;
                }
                let event_id = info.event_id;
                if (utilsModel.isValidNumberValue(event_id)) {
                    let bFind = false;
                    for (let o of gameData.delayTimeEventList) {
                        if (o.id == event_id) {
                            bFind = true;
                            break;
                        }
                    }
                    if (!bFind) {
                        NormalGameManager._instance.addDelayTimeEvent(event_id, 1);
                    }
                    // gameData.bMarryPawnBoos = true;
                    // this.writeGameData();
                }
            } else { 
                gameData.bMarryPawnBoos = true;
                this.writeGameData();
            }
        } 
    }

    //触发突发事件
    triggerEmergency() {
        let ary = this.getGameData().todayTimeEvents;
        if (ary.length < 1) {
            return;
        }
        let hour = this.getCurrentHour();
        for (let i = ary.length - 1; i >= 0; i--) {
            let eId = ary[i];
            let event = getOneNormalEventNewById(eId);
            let eHour = event.startTime || 12;
            if (hour >= eHour) {
                this.addOneEvent(eId);
                ary.splice(i, 1);
            }
        }
        this.writeGameData();
    }

    checkCanShowEvent(event: NormalEvent_New) {
        if (event) {
            let type = event.type;
            // 4 恋爱记 事件
            return type == "2" || type == "3" || type == "4";
        }
        return false;
    }

    private nodeStrs: string[] = [];
    private scheduleCallBack ;

    //开始检查 闲置 通知
    startCheckIdleNotice() {
        if ( !this.getGameData().idleNoticeFlag ) {
            this._currRunSeconds = 0;
            if( this.scheduleCallBack ){
                this.mGameLayer.unschedule( this.scheduleCallBack );
            }
            this.scheduleCallBack = this.checkTimer.bind(this);
            this.mGameLayer.schedule(  this.scheduleCallBack , 1 );
        }
    }


    //检查 是否 闲置提醒
    checkTimer(  ){
        //
        // if ( this._currRunSeconds == gameConfig.IDLE_NOTICE_SECONDS && !this.getGameData().idleNoticeFlag ) {
        if ( this._currRunSeconds == 10) {
            // let idleNoticePrefab = cc.instantiate(this.mGameLayer.idleNoticePrefab);
            // this.mGameLayer.node.addChild( idleNoticePrefab );
            //
            // this.setGameData({idleNoticeFlag : true} , false );
            this.mGameLayer.openRandomEvent();
            if( this.scheduleCallBack ){
                this.mGameLayer.unschedule( this.scheduleCallBack );
            }
            return;
        }
        // console.log( this._currRunSeconds );
        this._currRunSeconds++;
    }

    addOneNodeStrs(str: string) {
        this.nodeStrs.push(str);
        if( this.scheduleCallBack ){
            this.mGameLayer.unschedule( this.scheduleCallBack );
        }
    }

    spliceOneNodeStrs(str: string) {
        for (let i = this.nodeStrs.length - 1; i >= 0; i--) {
            let s = this.nodeStrs[i];
            if (s == str) {
                this.nodeStrs.splice(i, 1);
            }
        }

        // if ( this.nodeStrs.length == 0 && !this.getGameData().idleNoticeFlag ) {
        if ( this.nodeStrs.length == 0) {
            this._currRunSeconds = 0;
            if( this.scheduleCallBack ){
                this.mGameLayer.unschedule( this.scheduleCallBack );
            }
            this.scheduleCallBack = this.checkTimer.bind(this);
            this.mGameLayer.schedule(  this.scheduleCallBack , 1 );
        }
    }

    getNodeStr() {
        return this.nodeStrs;
    }

    openEggSynthesisPage(){
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`prefab/page/eggSynthesisPage`
        ,(err,prefab:cc.Prefab)=>{
            if(err){
                console.debug(err);
                return;
            }
            let node:cc.Node = cc.instantiate(prefab);
            node.setParent((O1HD.getModules().uiControlModule.getUIRoot()));
        });
    }

    /**
         * 背包物品添加
         */
    onPushGoods(id: number|string, num: number = 1, bShowSuper: boolean = true) {
        let bp = this.getGameData().backpack
        let goods = backPackEventMap()[id];
        if (!goods) return;

        if (goods.bInTimeSell) {
            let tPrice = goods.sellPrice*num;
            O1HD.getServices().userSrv.setCoins(tPrice, true);
            return;
        }
        //@ts-ignore
        if (this.onTreasureMapDispose(id)) {
            if (num == 1) {
                return;
            }
            num--;
        }

        let obj = bp[id];
        if(obj){
            obj.num += num;
            console.log(`物品${goods.name}增加了${num}`);
        }
        if (!obj) {
            bp[id] = {
                backId:id,
                num:num,
                isSell:false,
            }
            console.log(`新物品${goods.name}增加了${num}`);
            if (bShowSuper) {
                //@ts-ignore
                this.superPowerPropDispose(id);
            }
        }
        
        this.writeGameData();

        if (id == GeneralKind.PropId.CUPID_ARROW_ID) {
            let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
            matchMiaiDataManage.addCupidArrow();
        }

        // this.setGameData({
        //     backpack: bp
        // }, false)
        //凤凰蛋是否生成
        if ( !this.getGameData().phoenixEggFlag && id == 10378 ) {
            this.setGameData( { phoenixEggFlag : true } , false );
            O1HD.getModules().uiControlModule.showMessageBox("恭喜解锁夜明珠意外获得凤凰蛋" );
            this.onPushGoods( 21005 , 1 );
            return;
        }
        //判断龙蛋是否生成
        //需要 雷之精华 火之精华 风之精华 木之精华 海之精华 凤凰蛋
        if ( !this.getGameData().dragonEggFlag && bp[10383] && bp[10383].num > 0
            && bp[10384] && bp[10384].num > 0 && bp[10385] && bp[10385].num > 0 
            && bp[10386]?.num > 0 && bp[10391]?.num > 0 && bp[21005]?.num > 0 ) {
            this.setGameData( { dragonEggFlag : true } , false );
            O1HD.getModules().uiControlModule.showMessageBox("恭喜成功获得神龙蛋" );
            this.openEggSynthesisPage();
            this.onPushGoods( 21006 , 1 );
            return;
        }
    }

    /**背包物品消耗 */
    onOutGoods(id: number, num: number = 1) {
        let bp = this.getGameData().backpack
        let obj = bp[id];
        if(obj){
            obj.num -= num;
            if(obj.num <= 0){
                delete bp[id];
            }
        }
        this.setGameData({
            backpack: bp,
        }, false);
        O1HD.emit("normalMode.updateLieYing");
    }

    /**
     * 获取背包中的某件物品
     * @param goodId 物品id
     * @returns 物品详细
     */
    getOneGood(goodId:number){
        let bp = this.getGameData().backpack;
        return bp[goodId];
    }

    /**
     * 超级权限道具处理
     * @param id 
     */
    superPowerPropDispose(id: number) {
        let bOwn = SuperPowerKind.SuperPowerPropList.includes(id);
        if (!bOwn) {
            return;
        }
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.SuperPowerCompoundLayer
            , null
            , {
                newPropList: [id]
            }
            , UI_Z_INDEX.DIALOG
            , null
            , false
        );
    }

    /**
     * 藏宝图
     * @param id 
     */
    onTreasureMapDispose(id: number) {
        let t = TreasureMapCollect;
        let nidx = t.indexOf(id);
        if (nidx == -1) {
            return false;
        }

        let gameData = this.getGameData();
        if (!gameData.treasureMap[nidx]) {
            gameData.treasureMap[nidx] = true;
            NormalGameManager._instance.writeGameData();
            return true;
        } 
        return false;
    }

    /**股票价格刷新 */
    async onStockPriceChange(cb?, isPriceChange: boolean = true) {
        console.log("股票价格改变");
        this.stockRestCount++;
        let stockPriceArray = this.getGameData().stockPriceArray;
        let stockArray = this.getGameData().stockArray;
        if (stockPriceArray.length == 0) {
            let bundle = await getOneBundle(BUNDLE_SMALL_NAME.stockGameBundle);
            bundle.load(`stock/json/stock`, cc.JsonAsset, (error, assets: cc.JsonAsset) => {
                if (error) {
                    console.log(error);
                    return;
                }
                for (let index = 0; index < assets.json.length; index++) {
                    let random = parseFloat((Math.random() * 30 - 15).toFixed(2)) * 0.01;
                    //到固定天数，会有一支固定的股票会涨
                    if (this.getCurrentDay() + 1 == assets.json[index].order) {
                        random = Math.abs(random);
                    }
                    //股神选中的产业大概率会涨
                    if (gameConfig.STOCK_PRICE_ADD == assets.json[index].name) {
                        let random2 = Math.random();
                        if (random2 > 0.8) {
                            random = Math.abs(random);
                        }
                    }
                    let stockPrice: NormalStockPriceI = {
                        id: assets.json[index].id,
                        name: assets.json[index].name,
                        count: assets.json[index].numb,
                        price: parseInt((assets.json[index].price + (assets.json[index].price
                             * random)).toString()),
                        priceInit: assets.json[index].price,
                        percentage: random,
                        order: assets.json[index].order,
                        bankruptcy: 0
                    }
                    stockPriceArray.push(stockPrice);
                }
                this.setGameData({ stockPriceArray: stockPriceArray }, false);
                cb && cb()
            })
        } else {
            for (let index = 0; index < stockPriceArray.length; index++) {
                if (isPriceChange) {
                    let random = parseFloat((Math.random() * 30 - 15).toFixed(2)) * 0.01;
                    //玩家买的股票大概率会跌
                    stockArray.forEach(element => {
                        if (element.id == stockPriceArray[index].id) {
                            let random2 = Math.random();
                            if (random2 < 0.7) {
                                random = -Math.abs(random);
                            }
                        }
                    })
                    //到固定天数，会有一支固定的股票会涨
                    if (this.stockRestCount == stockPriceArray[index].order) {
                        this.stockRestCount = (this.stockRestCount % stockPriceArray.length);
                        random = Math.abs(random);
                        // console.log(this.getCurrentDay());
                        // console.log("增加的股票：", stockPriceArray[index].name);
                    }
                    //股神选中的产业大概率会涨
                    if (gameConfig.STOCK_PRICE_ADD == stockPriceArray[index].name) {
                        let random2 = Math.random();
                        if (random2 < 0.75) {
                            random = Math.abs(random);
                        }
                    }
                    stockPriceArray[index].percentage = random;
                    stockPriceArray[index].price = parseInt((stockPriceArray[index].price 
                        + (stockPriceArray[index].price * random)).toString());
                }
                //股票低于初始值的百分之80就破产
                if (stockPriceArray[index].priceInit * 0.2 >= stockPriceArray[index].price 
                    && stockPriceArray[index].bankruptcy <= 0) {
                    stockArray.forEach(element => {
                        if (element.id == stockPriceArray[index].id) {
                            this.onStockCountChange(element.id, -element.count)
                            let url = "stockMode/stockBankruptcyPrefab"
                            getOneBundleOnePrefab(BUNDLE_SMALL_NAME.stockGameBundle,url).then((prefab=>{
                                let newNode = cc.instantiate(prefab)
                                newNode.getComponent(StockBankruptcyPrefab).bindData(
                                    stockPriceArray[index].name)
                                O1HD.Canvas().addChild(newNode)
                            }))
                        }
                    });
                    stockPriceArray[index].bankruptcy = this.mMinute + 60 * this.mGameHours + 24 * 60;
                    stockPriceArray[index].price = 0;
                } else if (stockPriceArray[index].priceInit * 0.2 >= stockPriceArray[index].price 
                    && stockPriceArray[index].bankruptcy <= this.mMinute + 60 * this.mGameHours
                     && stockPriceArray[index].bankruptcy > 0) {
                    stockPriceArray[index].bankruptcy = 0;
                    stockPriceArray[index].price = stockPriceArray[index].priceInit;
                }
            }
            this.setGameData({ stockPriceArray: stockPriceArray }, false);
            cb && cb();
        }
    }
    /**玩家股票数量改变 */
    onStockCountChange(id, count) {
        let stockPriceArray = this.getGameData().stockPriceArray;
        let stockArray = this.getGameData().stockArray;
        if (count >= 0) {
            let isHave = false
            stockArray.forEach((element, index) => {
                if (element.id == id) {
                    isHave = true;
                    let priceNow = 0;
                    stockPriceArray.forEach(element => {
                        if (id == element.id) {
                            element.count -= count;
                            priceNow = element.price;
                        }
                    })
                    element.buyPrice = Math.floor(((element.buyPrice * element.count) 
                    + (count * priceNow)) / (element.count + count));
                    element.count += count;
                    return;
                }
            })
            if (!isHave) {
                stockPriceArray.forEach(element => {
                    if (id == element.id) {
                        element.count -= count;
                        let stock: NormalStockI = {
                            id: element.id,
                            name: element.name,
                            count: count,
                            buyPrice: element.price,
                        }
                        stockArray.push(stock);
                        return;
                    }
                });
            }
        } else {
            stockPriceArray.forEach(element => {
                if (id == element.id) {
                    element.count -= count;
                    return;
                }
            });
            stockArray.forEach((element, index) => {
                if (id == element.id) {
                    element.count += count
                    if (element.count <= 0) {
                        stockArray.splice(index, 1);
                    }
                    return;
                }
            });
        }
        this.setGameData({ stockPriceArray: stockPriceArray, stockArray: stockArray }, false);
    }

    async openOneNewEvent() {
        let eventIds: string[] = this.getGameData().eventQueue;

        //聊完天 结束之后的 弹窗
        let eventId = eventIds.find(event => {
            let eve = getOneNormalEventNewById(event);
            return eve.type == "4";
        });
        if ( eventId ) {
            let index = eventIds.findIndex(event => {
                return event == eventId;
            });
            if (index > -1) {
                eventIds.splice(index, 1);
            }
        }else{
            if (eventIds.length == 0 || this.getGameData().todayEventCount >= gameConfig.TODAY_EVENT_COUNT) {
                this.mGameLayer.canShowFlag = true;
                return;
            }
            this.mGameLayer.canShowFlag = false;
            //聊完天 结束之后的 弹窗
            eventId = eventIds.find(event => {
                let eve = getOneNormalEventNewById(event);
                return eve.type == "2";
            });
            //聊天 里面看广告后 触发的 告知《看了聊天广告视频之后获得什么东西》
            if (!eventId) {
                eventId = eventIds.find(event => {
                    let eve = getOneNormalEventNewById(event);
                    return eve.type == "3";
                });
            }
            //开场白
            if (!eventId) {
                eventId = eventIds.find(event => {
                    let eve = getOneNormalEventNewById(event);
                    return eve.type == "1";
                });
            }

            //普通的正常告知
            if (eventId != null) {
                let index = eventIds.findIndex(event => {
                    return event == eventId;
                });
                if (index > -1) {
                    eventIds.splice(index, 1);
                }
            } else {
                eventId = eventIds.shift();
            }
        }

        this.writeGameData();

        let event = getOneNormalEventNewById(eventId);
        if (event && !this.checkCanShowEvent(event)) {
            this.getGameData().todayEventCount++;
        }
        let eventNode: cc.Node = null;
        let eventPrefab:cc.Prefab = null;
        switch (event.type) {
            //开场白  事件
            case "1": {
                eventPrefab = await getOneBundleOnePrefab(
                    BUNDLE_SMALL_NAME.eventGameBundle
                    ,"prefab/normalChatEventShow");
                eventNode = cc.instantiate(eventPrefab);
                let es = eventNode.getComponent(normalChatEvent_New);
                es.bindEvent(eventId, this.mGameLayer);
                break;
            }
            case "4":{
                // 恋爱屋事件
                eventPrefab = await getOneBundleOnePrefab(
                    BUNDLE_SMALL_NAME.eventGameBundle
                    ,"prefab/normalNewEventShow_loveStroy");
                eventNode = cc.instantiate(eventPrefab);
                let es = eventNode.getComponent(normalEventNewBase);
                es.bindEvent(eventId, this.mGameLayer);
                break;
            }
            default: {
                // 通知事件
                eventPrefab = await getOneBundleOnePrefab(
                    BUNDLE_SMALL_NAME.eventGameBundle
                    ,"prefab/normalNewEventShow");
                eventNode = cc.instantiate(eventPrefab);
                let es = eventNode.getComponent(normalEventNewBase);
                es.bindEvent(eventId, this.mGameLayer);
                break;
            }
        }
        O1HD.Canvas().addChild(eventNode);
    }

    //注册一个银行业务
    registerOneBankBusiness(bankId:number){
        let bankCooperativeData = getBankCooperativeMap()[bankId];
        let bankAry :number[] = this.getGameData().bankCooperativeData;
        if(bankCooperativeData){
            bankAry.push(bankId);
            this.writeGameData();
        }
    }
    //注册一个养殖业务
    registerOneBreedBusiness(breedId:number){
        let breedCooperativeData = getBreedCooperativeMap()[breedId];
        let breedAry :number[] = this.getGameData().breedCooperativeData;
        if(breedCooperativeData){
            breedAry.push(breedId);
            this.writeGameData();
        }
    }
    //删除一个银行业务
    deleteOneBankBusiness(bankId:number){
        let bankAry :number[] = this.getGameData().bankCooperativeData;
        let index = bankAry.indexOf(bankId);
        if(index > -1){
            bankAry.splice(bankId);
            this.writeGameData();
        }
    }
    //删除一个养殖业务
    deleteOneBreedBusiness(breedId:number){
        let breedAry :number[] = this.getGameData().breedCooperativeData;
        let index = breedAry.indexOf(breedId);
        if(index > -1){
            breedAry.splice(breedId);
            this.writeGameData();
        }
    }

    /**
     * 打开银行贷款界面
     * @param completeFun 
     */
    async openBankPage(completeFun?:(isTrue:boolean)=>void){
        // let bankP:cc.Prefab = await getOneBundleOnePrefab(
        //     BUNDLE_SMALL_NAME.cooperativeGameBundle
        //     ,"cooperativeGame/bankBusinessPage");
        // if(bankP){
        //     let bankNode:cc.Node = cc.instantiate(bankP);
        //     let ns = bankNode.getComponent(cooperativeBankPage);
        //     ns.bindData(completeFun);
        //     bankNode.setParent(O1HD.getModules().uiControlModule.getUIRoot());
        // }
        this.openLoanPage("noMoney",completeFun);
    }

    //加一条银行贷款信息
    onAddOneBankBusiness(){
        if(NormalGameManager._instance.getGameData().hasBankCooperativeData.length >=2){
            NormalGameManager._instance.addOneEvent("4");
        }
    }

    //删除一条银行贷款信息
    spliceOneHasBankCooperativeById(hasId:number){
        let index = this.getGameData().hasBankCooperativeData.findIndex(id=>{
            return id == hasId;
        });
        if(index >-1){
            this.getGameData().hasBankCooperativeData.splice(index,1);
            this.writeGameData();
        }
    }

    addOneCooperativeById(id:number){
        let oneCooperative = getCooperativeShopMap()[id];
        let findCooperative :cooperativeShopSaveItem[] = JSON.parse(
            JSON.stringify(this.getGameData().hasShopCooperativeData));
        let index = findCooperative.findIndex((value)=>{
            return value.id == id;
        });
        if(oneCooperative.isOnly && index > -1){
            O1HD.getModules().uiControlModule.showMessageBox("已经开过了");
            return;
        }
        let newCooperative:cooperativeShopSaveItem ={
            id:id,
            openTime:this.mGameHours
        }
        this.getGameData().hasShopCooperativeData.push(newCooperative);
    }

    spliceCooperativeByTime(){
        let ary:cooperativeShopSaveItem[] = this.getGameData().hasShopCooperativeData;
        let config = getCooperativeShopMap();
        for(let i = ary.length -1; i>=0; i--){
            let iData = ary[i];
            let iConfig = config[iData.id];
            if(this.mGameHours >= (iData.openTime + iConfig.vaildHour)){
                ary.splice(i,1);
            }
        }
    }
    
    addExp(exp: number) {
        let gameData = this.getGameData();
        let curExp = Math.max(0, gameData.m_reputation + exp);
        let curLv = CsvDataManage.instance.getUserUpdateLevel(curExp);
        let oldLv = gameData.m_officialLv;
        this.setGameData({m_reputation: curExp, m_officialLv: curLv}, false);
        O1HD.emit(MessageEventKind.EventName.UPDATE_EXP);
        if (oldLv != curLv) {
            O1HD.emit(MessageEventKind.EventName.UPDATE_LEVEL);
            O1HD.emit(MessageEventKind.EventName.PROMOTE_LEVEL);
            DataVariationManage.instance.updateData(
                ConditionKind.ConditionsType.LEVEL
            );
        }
    }

    promoteLevel() {
        let gameData = this.getGameData();
        let officialLv = gameData.m_officialLv;
        let reputation = gameData.m_reputation;

        let csvInfos = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEVEL, officialLv+1);
        if (!csvInfos) {
            console.log(`达到顶级`);
            return;
        }
        let lvExp = Number(csvInfos.exp.replace(/,/g, ''));
        if (reputation < lvExp) {
            console.log(`未达到升级条件`);
            return;
        }

        this.setGameData({m_officialLv: officialLv+1}, false);
        O1HD.emit(MessageEventKind.EventName.UPDATE_LEVEL);
        O1HD.emit(MessageEventKind.EventName.UPDATE_EXP);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.ExamSuccessLayer
            , null
            , {}
        );
    }

}

/**
 * 事件 - 用户属性
 */
export interface EventUserEntity {
    id: number;
    startValue: number;//开始值
    endValue: number;//结束值
    weight: number;//触发权重
    modeDefine?: string;//
    desc: string;//描述
    effectParams: { key: number, value: number };//影响类型
}


/**
 * 特殊的事件
 */
export interface RegisterSpecialEventEntity {
    startHours: number;//开始时间
    waitHours: number;//需等待小时
    type?: number;//类型 null 事件弹窗 ,1 告知弹窗
    nextFlag?: boolean;//后续事件
    desc: string;//描述
    imgPath?: string;//图片路径
    effectParams?: { key: number, value: number }[];//影响类型
    chooseArray?: { chooseItemName: string, desc: string, imgPath?: string
        , effectParams: { key: number, value: number }[] }[];//选项组 数组
}

export interface RegisterSpecialEventEntityCopy extends RegisterSpecialEventEntity {
    chooseArray?: { chooseItemName: string, desc: string, imgPath?: string
        , effectParams: { key: number, value: number }[]
        , clickFun: () => Promise<any>, isHasNext: boolean }[]; // 选项数组
    isNext: boolean;
    closeFun?: () => Promise<any>;
}



